function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.674 1.247h8.652v-.201a.746.746 0 0 1 1.492 0v.201H18.4a.8.8 0 0 1 .8.8V18.9a.8.8 0 0 1-.8.8H1.6a.8.8 0 0 1-.8-.8V2.047a.8.8 0 0 1 .8-.8h2.582v-.201a.746.746 0 0 1 1.492 0v.201zm12.034 4.888H2.292v12.069h15.416V6.134z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.076 8.822a.74.74 0 0 1 0 1.048l-4.529 4.524a.716.716 0 0 1-1.012 0l-2.01-2.009a.74.74 0 0 1 1.045-1.047l1.471 1.47 3.989-3.986a.74.74 0 0 1 1.046 0z"
});

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    id: "icon-calendar-stroke",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.e7d53b06.svg";
export { ForwardRef as ReactComponent };